
















import { Component } from 'vue-mixin-decorator';
import axios from 'axios';
import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';

@Component({
  components: {
    'e-footer': ExamFooter,
    'e-guide': ExamGuide,
    'e-nav': ExamNav,
  },
})
export default class Privacy extends BaseView {
  private main = '';

  async mounted() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);

    // 外部HTMLを読み込み
    const main = await axios.get(`${process.env.VUE_APP_BASE_URL}/static/privacy_main.html`)
      .then((response) => response.data);
    if (typeof main === 'string') {
      this.main = main;
    }
  }
}
